import { API_URL } from "../constants/api";
import { utils_api } from "../utils/utils_api";

export const api_logout = {
  logout(success, fail) {
    return utils_api.auth_get(API_URL.LOGOUT_GET, success, fail);
  },
};
